export function extractBadgeDetails(badges) {
    const result = [];

    for (const [providerKey, providerData] of Object.entries(badges)) {
        const { ClientID, Office, Badgeandtopic = [], userName, password } = providerData;

        for (const badgeObj of Badgeandtopic) {
            const { Badge, _id: bID, Topic = [] } = badgeObj;

            for (const topic of Topic) {
                result.push({
                    Main: providerKey,
                    mainID: providerData._id,
                    ClientID,
                    Office,
                    Badge,
                    userName, password,
                    bID,
                    topic: topic.name,
                    tID: topic._id
                });
            }
        }
    }

    return result;
}